module.exports = __webpack_public_path__ + "chatting.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/assets/img/chatting.png
// module id = 2190
// module chunks = 13